import React, { Component } from 'react';
import config from 'react-global-configuration';
import RequestApi from '../Miscelania/RequestApi';

import { Link, Redirect } from 'react-router-dom';

import InputMask from 'react-input-mask';
import Select from 'react-select';

import Topo from '../Layout/Topo';
import Overlay from '../Miscelania/Overlay';
import getLocale from '../../i18n/getLocale';

class FatigueEffectivenessAdd extends Component {
  // constructor
  constructor(props) {
    super(props);

    this.state = {
      overlay: {
        message: '',
        type: '',
        status: 'open',        
      },
      redirect_url: false,
      loaded: 0,
      data: {},
      sections: {},
      bases_list: [],
      month_year: '',
    };

    //Handlers
    this.handleAlert = this.handleAlert.bind(this);
    this.handleLoaded = this.handleLoaded.bind(this);
    this.handleMessage = this.handleMessage.bind(this);

    this.locale = getLocale();

    this.add = this.add.bind(this);
  }
  // Handlers
  handleChangeData (name, event) {
    var change = {};
    change[name] = event.target.value;
    this.setState(change);
  }

  handleSelectChangeApplicability(name, event) {
    var change = {};
    if(event == null) {
      change[name] = null;
    } else {
      change[name] = event.value;
      var self = this;
      self.setState({overlay: {message: this.locale.Formularios.CadastrarFormulario.mensagemFormularioEstaSendoGerado, type: 'info', status: 'open'}});

      var datasave = {
        month_year: this.state.month_year,
        applicability_id: event.value,
      };
      var header = this.refs.request_api.header('application/json');
      Promise.resolve(header).then(function(value) {
        fetch(config.get('api') + '/formulario/mensal', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
          self.refs.request_api.validate(responseJson, 'alert');
          if (responseJson.status === 'success') {
            self.setState({sections: responseJson.data});
          }
          self.handleAlert(responseJson.message, responseJson.status, 'closed');
        }).catch((error) => {
          console.error(error);
        });
      });
    }
    this.setState(change);
  }

  handleChange (name, event) {
    var change = {};
    var self = this;
    var data_temp = {...self.state.sections};
    Object.keys(self.state.sections).map(function(k) {
      Object.keys(self.state.sections[k]).map(function(kj) {
        Object.keys(self.state.sections[k][kj]).map(function(kjj) {
          if(self.state.sections[k][kj][kjj].id === name) {
            data_temp[k][kj][kjj] = {
              value: event.target.value,
              field_name: self.state.sections[k][kj][kjj].field_name,
              field_type_str: self.state.sections[k][kj][kjj].field_type_str,
              field_type: self.state.sections[k][kj][kjj].field_type,
              required: self.state.sections[k][kj][kjj].required,
              automatic_field: self.state.sections[k][kj][kjj].automatic_field,
              id: self.state.sections[k][kj][kjj].id,
            };
            
          }
        })
      })
    });
    this.setState({sections: data_temp});
  }
  
  handleAlert(message, type, status, mode) {
    if(mode === 'reset') {
      this.setState({overlay: {message: '', type: '', status: 'closed'}});
    } else {
      this.setState({overlay: {message: message, type: type, status: status}});
    }
  }

  handleMessage () {
    var message = localStorage.getItem("verify_message");
    if (message !== null && typeof message !== 'undefined') {
      message = JSON.parse(message);
      var self = this;
      self.setState({overlay: {message: message.alert_message, type: message.alert_type, status: 'open'}});
      localStorage.removeItem("verify_message");
    }
  }

  handleLoaded(state) {
    if(this.state.loaded !== 2) {
      this.setState({loaded: state});      
    }
  }

  // Setamos o state.date_start para a data de hoje
  componentWillMount () {
    var now = new Date();
    var month = now.getMonth()+1;
    var year = now.getFullYear();

    if (month < 10) {
      month = '0' + month;
    }
  
    var month_year = month + '/' + year;
    this.setState({month_year: month_year});
  }

  componentDidMount () {
    this.refs.request_api.header();
  }

  componentDidUpdate(prevProps, prevState) {
    if(this.state.loaded === 1 && prevState.loaded === 0) {
      this.setState({loaded: 2}, this.loadData());
    }
  }

  loadData () {
    var self = this;
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      var url = config.get('api') + '/parametros-de-fadiga/listagens';
      fetch(url, { method: 'GET', mode: 'cors', headers: value }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'url');
        if (responseJson.status === 'success') {
          var today = new Date();

          var date = today.getFullYear()+'-'+(today.getMonth()+1)+'-'+today.getDate();
          self.setState({applicabilities_list: responseJson.data.applicabilities});
        }
      }).then(() => {
        self.setState({overlay: {message: '', type: '', status: 'closed'}});
      }); /* Overlay */
    });
  }

  add(event) {
    event.preventDefault();
    var self = this;
    self.setState({overlay: {message: '', type: '', status: 'open'}});
    var datasave = {
      sections: this.state.sections,
      month_year: this.state.month_year,
      applicability_id: this.state.applicability_id,
    };
    var header = this.refs.request_api.header('application/json');
    Promise.resolve(header).then(function(value) {
      fetch(config.get('api') + '/formulario/mensal/cadastrar', { method: 'POST', mode: 'cors', headers: value, body: JSON.stringify(datasave) }).then((response) => response.json()).catch((error) => { console.error(error); }).then((responseJson) => {
        self.refs.request_api.validate(responseJson, 'alert');
        if (responseJson.status === 'success') {
          var url = '/formulario/editar/' + responseJson.data.id;
          var storage = {
            alert_message: responseJson.message,
            alert_type: responseJson.status,
          };
          localStorage.setItem("verify_message", JSON.stringify(storage));
          self.setState({redirect_url: url});
          
        }
        self.setState({overlay: {message: responseJson.message, type: responseJson.status, status: 'open'}});
      }).catch((error) => {
        console.error(error);
      });
    });
  }

  render() {
    var self = this;
    return (
<div>
  <Topo promptInstall={this.props.promptInstall}></Topo>
  <RequestApi ref={'request_api'} handleLoaded={this.handleLoaded} />
  <Overlay overlay={this.state.overlay} handleAlert={this.handleAlert} />
  {this.state.redirect_url ? <Redirect to={{pathname: this.state.redirect_url}}/> : ""}
  <div>
    <div className="conteudo">
    
      <h3 className="page-title pull-left">{this.locale.Formularios.CadastrarFormulario.titulo}</h3>
      <Link to="/formularios" className="btn btn-default pull-right"><i className="fa fa-chevron-left"></i> {this.locale.general.voltar}</Link>
      <div className="clearfix"></div>
      <hr/>
      <form onSubmit={this.add}>
        <div className="row">
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.Formularios.CadastrarFormulario.formulario.Data}:</label>
              <InputMask value={this.state.month_year} required maskChar={null} name="month_year" mask="99/9999" className="form-control" onChange={this.handleChangeData.bind(this, 'month_year')} placeholder="" />
            </div>
          </div>
          <div className="col-md-6">
            <div className="form-group">
              <label>{this.locale.Formularios.CadastrarFormulario.formulario.Aplicabilidade}:</label>
              <Select
                className="form-field-name"
                name="applicability_id"
                value={this.state.applicability_id}
                searchable={true}
                placeholder={this.locale.Formularios.CadastrarFormulario.formulario.placeholder.SelecionarAplicabilidade}
                onChange={this.handleSelectChangeApplicability.bind(this, 'applicability_id')}
                options={this.state.applicabilities_list}
              />
            </div>
          </div>
        </div>
        <hr/>
        {Object.keys(self.state.sections).map(function(k) {
          return (
            <div className="row">
              <div className="col-md-12">
                <h2>{k}</h2>
                <hr/>
                {Object.keys(self.state.sections[k]).map(function(kj) {
                  return (
                      <div className="row">
                        <div className="col-md-12">
                          <h4>{kj}</h4>
                          <hr/>
                          {Object.keys(self.state.sections[k][kj]).map(function(kjj) {
                            return (
                              <div className="form-group">
                                <label>{self.state.sections[k][kj][kjj].field_name + " - " + self.state.sections[k][kj][kjj].field_type_str}{(self.state.sections[k][kj][kjj].required === 1) ? '***' : ''}</label>
                                {(self.state.sections[k][kj][kjj].field_type === 'time') ?
                                  <InputMask required={self.state.sections[k][kj][kjj].required} value={self.state.sections[k][kj][kjj].value} maskChar={null} name={self.state.sections[k][kj][kjj].id} mask="99:99" className="form-control" onChange={self.handleChange.bind(self, self.state.sections[k][kj][kjj].id)} placeholder={this.locale.Formularios.CadastrarFormulario.formulario.placeholder.Horas} />    
                                  :
                                  <input required={self.state.sections[k][kj][kjj].required} type="text" name={self.state.sections[k][kj][kjj].id} className={"form-control"} placeholder={this.locale.Formularios.CadastrarFormulario.formulario.placeholder.Quantidade} value={self.state.sections[k][kj][kjj].value} onChange={self.handleChange.bind(self, self.state.sections[k][kj][kjj].id)} />
                                }
                              </div>
                            );
                          })}
                        </div>
                      </div>
                  );
                })}

              </div>
            </div>
          );
        })}
        <hr/>
        <button type="submit" className="btn btn-primary btn-block btn-lg"><i className="fa fa-fw fa-search"></i> {this.locale.Formularios.CadastrarFormulario.formulario.botaoCadastrarFormulario}</button>
      </form>
    </div>
  </div>
</div>
    );
  }
}

export default FatigueEffectivenessAdd;



// WEBPACK FOOTER //
// ./src/Components/FatigueEffectiveness/FatigueEffectivenessAdd.js